module.exports = __webpack_public_path__ + "static/oknoplast-6dc58081a99cccf3525ab2d3d67218d5.png";